import { useQuery } from '@apollo/client'
import { Button } from 'components/atoms'
import Invoices from 'components/me/subscriptionManagement/Invoices/Invoices'

import { INVOICES } from '@/graphql/queries/user'

const Container = () => {
  const userQuery = useQuery(INVOICES, {
    variables: {
      perPage: 5,
      lastInvoiceId: null,
    },
  })

  if (userQuery.loading || !userQuery.data?.me) {
    return null
  }

  const handleFetchMore = () => {
    userQuery.fetchMore({
      variables: {
        lastInvoiceId: userQuery.data.me.invoices.at(-1).id,
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        if (!fetchMoreResult) {
          return previousResult
        }

        return {
          me: {
            ...previousResult.me,
            invoices: [
              ...previousResult.me.invoices,
              ...fetchMoreResult.me.invoices,
            ],
          },
        }
      },
    })
  }

  return (
    <>
      <Invoices invoices={userQuery.data.me.invoices} />
      <Button
        variant="load"
        onClick={handleFetchMore}
      >
        Voir plus de factures
      </Button>
    </>
  )
}

export default Container
